export default "__VITE_ASSET__12529680__"